/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom SMTP email delivery configuration.
 * @export
 * @interface GetServiceprovider200ResponseCustomEmail
 */
export interface GetServiceprovider200ResponseCustomEmail {
    /**
     * Whether custom email delivery is active.
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetServiceprovider200ResponseCustomEmail interface.
 */
export function instanceOfGetServiceprovider200ResponseCustomEmail(value: object): value is GetServiceprovider200ResponseCustomEmail {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseCustomEmailFromJSON(json: any): GetServiceprovider200ResponseCustomEmail {
    return GetServiceprovider200ResponseCustomEmailFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseCustomEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200ResponseCustomEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function GetServiceprovider200ResponseCustomEmailToJSON(json: any): GetServiceprovider200ResponseCustomEmail {
    return GetServiceprovider200ResponseCustomEmailToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseCustomEmailToJSONTyped(value?: GetServiceprovider200ResponseCustomEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

